import http from  './axios'

export const cancelWaitCharge = param =>{return http.post("clinic-manager/case/delNoCharge",param).then(res=>res.data.data)};
//待收费取消
export const noChargeCount = param =>{return http.post("clinic-manager/case/getHisNoChargeCount",param).then(res=>res.data.data)};
//未收费个数
export const noChargeList = param =>{return http.post("clinic-manager/case/getHisNoChargeList",param).then(res=>res.data.data)};
//未收费列表
export const waitChargeDetail = param =>{return http.post("clinic-manager/case/noChargeById",param).then(res=>res.data.data)};
//待收费详情
export const charge = param =>{return http.post("clinic-manager/case/charge",param).then(res=>res.data.data)};
//收费

export const haveChargeDetail = param =>{return http.post("clinic-manager/case/chargeDById",param).then(res=>res.data.data)};
//已收费详情
export const haveChargeList = param =>{return http.post("clinic-manager/case/getHisChargedList",param).then(res=>res.data.data)};
//已收费列表
export const refund = param =>{return http.post("clinic-manager/case/refund",param).then(res=>res.data.data)};
//退费

export const cancelRefund = param =>{return http.post("clinic-manager/case/delRefund",param).then(res=>res.data.data)};
//已退费取消
export const refundList = param =>{return http.post("clinic-manager/case/getHisRefundList",param).then(res=>res.data.data)};
//已退费列表
export const haveRefundDetail = param =>{return http.post("clinic-manager/case/refundById",param).then(res=>res.data.data)};
//已退费详情


// WEBPACK FOOTER //
// ./src/api/charge.js